import type { MouseEventHandler } from 'react'

import { useUnit } from 'effector-react'
import { NavLink } from 'react-router-dom'

import { $creatorId } from '@/models/creators.ts'

import { NavExpandableButton } from './nav-expandable-button.tsx'
import {
  NavSingleButton,
  type NavSingleButtonProps,
} from './nav-single-button.tsx'

export interface NavItemProps {
  item: NavSingleButtonProps
  onClick: MouseEventHandler<HTMLAnchorElement>
}

type NavLinkChildrenFnProps = Readonly<{
  isActive: boolean
  isPending: boolean
}>

export const NavItem = ({ item, onClick }: NavItemProps) => {
  const { href, children, hoverRoutes } = item

  const creatorId = useUnit($creatorId)

  return children ? (
    <NavExpandableButton
      isDisabled={false}
      subItems={children}
      {...item}
    />
  ) : (
    <NavLink
      caseSensitive
      to={href}
      onClick={onClick}
      target={
        href.startsWith('https://') || href.startsWith('http://')
          ? '_blank'
          : '_self'
      }
    >
      {({ isActive }: NavLinkChildrenFnProps) => (
        <NavSingleButton
          isActive={
            isActive ||
            (hoverRoutes &&
              !!hoverRoutes.find(
                (route) =>
                  route.replace(':creatorId', creatorId?.toString() ?? '') ===
                  window.location.pathname,
              ))
          }
          {...item}
        />
      )}
    </NavLink>
  )
}
